import { useCallback, useMemo, useState } from 'react'
import { FiAlertCircle, FiClipboard, FiMail, FiX } from 'react-icons/fi'

import { Button } from '~/components/Button'
import { Modal } from '~/components/Modal'
import { app_version } from '~/utils/version'

export const BugReportModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [copyStatus, setCopyStatus] = useState<'idle' | 'copied' | 'error'>(
    'idle',
  )

  const handleOpen = useCallback(() => {
    setIsOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setIsOpen(false)
    setCopyStatus('idle')
  }, [])

  const buildTemplate = useCallback(() => {
    const url = typeof window !== 'undefined' ? window.location.href : ''
    const userAgent =
      typeof window !== 'undefined' ? window.navigator.userAgent : ''

    return `Olá, encontrei um problema no GPA:

Descrição do bug:
- O que eu estava tentando fazer:
- O que aconteceu:
- Passos para reproduzir:

Dados úteis:
- Versão do app: ${app_version}
- Página: ${url}
- Navegador: ${userAgent}`
  }, [])

  const mailToHref = useMemo(() => {
    const subject = encodeURIComponent('Reporte de bug - GPA')
    const body = encodeURIComponent(buildTemplate())
    return `mailto:suporte@gpa.studio?subject=${subject}&body=${body}`
  }, [buildTemplate])

  const handleCopyTemplate = useCallback(async () => {
    try {
      if (!navigator?.clipboard) {
        setCopyStatus('error')
        return
      }

      await navigator.clipboard.writeText(buildTemplate())
      setCopyStatus('copied')
      setTimeout(() => setCopyStatus('idle'), 2000)
    } catch (error) {
      console.error('[BugReportModal] copy failed', error)
      setCopyStatus('error')
      setTimeout(() => setCopyStatus('idle'), 2000)
    }
  }, [buildTemplate])

  return (
    <>
  {/*    <button
        type='button'
        onClick={handleOpen}
        className='flex items-center gap-2 px-3 py-2 text-sm font-semibold text-gpa-blue-500 hover:text-gpa-blue-600 transition-colors'
      >
        <FiAlertCircle className='text-lg' />
        <span>Reportar bug</span>
      </button>*/}

      <Modal visible={isOpen}>
        <div className='flex justify-between items-start gap-3 mb-4'>
          <div className='flex items-center gap-2'>
            <FiAlertCircle className='text-gpa-blue-500' size={22} />
            <div>
              <p className='text-xs font-semibold text-gray-500'>
                Ajuda rápida
              </p>
              <h2 className='text-xl font-semibold'>Encontrou um bug?</h2>
            </div>
          </div>

          <button
            className='bg-white hover:bg-gpa-gray-50 p-1 rounded-full'
            onClick={handleClose}
            aria-label='Fechar'
            type='button'
          >
            <FiX size={22} />
          </button>
        </div>

        <div className='space-y-3 text-sm text-gray-700'>
          <p>
            Envie os detalhes abaixo para que possamos corrigir mais rápido.
            Inclua prints e os passos para reproduzir o problema.
          </p>

          <div className='rounded-lg border border-gray-200 bg-gray-50 p-3 text-xs font-mono leading-relaxed text-gray-700'>
            {buildTemplate().split('\n').map((line, idx) => (
              <p key={idx}>{line}</p>
            ))}
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
            <Button
              type='button'
              onClick={() => {
                window.location.href = mailToHref
              }}
              className='w-full'
            >
              <FiMail className='mr-2' />
              Abrir e-mail de suporte
            </Button>
            <Button
              type='button'
              mode='outlined'
              onClick={handleCopyTemplate}
              className='w-full'
            >
              <FiClipboard className='mr-2' />
              {copyStatus === 'copied'
                ? 'Copiado!'
                : copyStatus === 'error'
                  ? 'Falha ao copiar'
                  : 'Copiar modelo'}
            </Button>
          </div>

          <Button
            type='button'
            mode='blank'
            className='w-full justify-center'
            onClick={handleClose}
          >
            Fechar
          </Button>
        </div>
      </Modal>
    </>
  )
}
